function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import React from "react";
import cx from "classnames";
import debounce from "lodash/debounce";
import { postInitialCollect } from "../nav-util/api";
import { host } from "../nav-util/url";
var c = host.c;
var SearchPopover = /*#__PURE__*/function (_React$Component) {
  _inherits(SearchPopover, _React$Component);
  var _super = _createSuper(SearchPopover);
  function SearchPopover() {
    var _this;
    _classCallCheck(this, SearchPopover);
    _this = _super.apply(this, arguments);
    _this.state = {
      cursor: -1,
      mentions: [],
      recommend: [],
      default: [],
      placeholder: "",
      keyword: "",
      ads: undefined,
      activityStatus: 0,
      historyShow: false,
      resultShow: false,
      resultList: []
    };
    _this.inputRef = /*#__PURE__*/React.createRef();
    _this.duration = [];
    _this.browsingHistoryList = [];
    _this.pageName = "";
    _this.mention = debounce(function (value) {
      _this.suggest(value);
    }, 500);
    _this.handleInput = function (e) {
      var value = e.currentTarget.value;
      if (value === "") {
        _this.setState({
          historyShow: false,
          resultShow: false
        });
      }
      _this.setState({
        keyword: value
      });
      _this.mention(value);
    };
    _this.suggest = function (keyword) {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this2 = this;
        var resultList, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                resultList = [];
                if (!keyword) {
                  _context.next = 6;
                  break;
                }
                _context.next = 4;
                return this.props.fetchSearchSuggest({
                  keyword: keyword
                });
              case 4:
                res = _context.sent;
                if (res && res.status === 12000) {
                  resultList = _toConsumableArray(res.data.list);
                }
              case 6:
                this.setState({
                  resultList: resultList,
                  historyShow: false,
                  resultShow: true
                }, function () {
                  if (_this2.state.resultShow) {
                    _this2.state.resultList.forEach(function (item) {
                      _this2.props.ga4Collect("element_exposured", {
                        page_name: _this2.pageName,
                        module: "搜索欄",
                        sub_module: "搜索框",
                        element: "下拉框推薦詞",
                        element_id: item.data.title
                      });
                    });
                  }
                });
              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    };
    _this.highLight = function (str, keyword) {
      try {
        return str.replace(new RegExp(keyword, "gmi"), function (match) {
          return "<span style=\"color:#ff3232\">".concat(match, "</span>");
        });
      } catch (error) {
        return str;
      }
    };
    _this.handleKeyDown = function (e) {
      var cursor = _this.state.cursor;
      switch (e.keyCode) {
        case 38:
          e.preventDefault();
          break;
        case 40:
          e.preventDefault();
          break;
        case 13:
          e.preventDefault();
          _this.jump(cursor);
          break;
        default:
          break;
      }
    };
    _this.handleContainerClick = function (e) {
      var target = e.target;
      if (target.classList.contains("tc-search-mention") || target.id === "tcSearchInput") {
        return;
      }
      _this.setState({
        cursor: -1
      });
    };
    _this.handleFocus = function () {
      _this.setState({
        historyShow: _this.state.keyword === "" && _this.browsingHistoryList.length > 0 ? true : false,
        resultShow: _this.state.keyword !== "" ? true : false,
        placeholder: ""
      }, function () {
        if (_this.state.historyShow) {
          _this.browsingHistoryList.forEach(function (item) {
            _this.props.ga4Collect("element_exposured", {
              page_name: _this.pageName,
              module: "搜索欄",
              sub_module: "搜索框",
              element: "下拉歷史推薦詞",
              element_id: item
            });
          });
        }
        if (_this.state.resultShow) {
          _this.state.resultList.forEach(function (item) {
            _this.props.ga4Collect("element_exposured", {
              page_name: _this.pageName,
              module: "搜索欄",
              sub_module: "搜索框",
              element: "下拉框推薦詞",
              element_id: item.data.title
            });
          });
        }
      });
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      _this.setTimeDuration && clearInterval(_this.setTimeDuration);
      setTimeout(function () {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        _this.setTimeDuration && clearInterval(_this.setTimeDuration);
      }, 800);
    };
    _this.handleBlur = function () {
      setTimeout(function () {
        _this.setState({
          historyShow: false,
          resultShow: false,
          placeholder: _this.duration[0]
        });
      }, 200);
      _this.intervalDuration(_this.duration.length);
    };
    _this.jump = function (index) {
      var _a;
      var _this$state = _this.state,
        mentions = _this$state.mentions,
        keyword = _this$state.keyword,
        placeholder = _this$state.placeholder,
        ads = _this$state.ads;
      var adsObj = _this.state.default.filter(function (_) {
        return _.ads;
      })[0];
      var query = "";
      if (!index) {
        if (!!keyword) {
          query = keyword;
        } else {
          query = placeholder;
          if (ads) {
            _this.props.postInitialCollect(ads, "click", "searchViewButton");
          }
        }
      } else {
        var current = mentions[index];
        if (current) {
          query = current.text;
        } else {
          query = keyword;
        }
      }
      _this.props.ga(["关键字搜寻", "搜寻内容", query]);
      if (adsObj) {
        _this.ad(adsObj);
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        adsObj.ads && adsObj.ads.adclick !== "" && query === ((_a = adsObj.ads) === null || _a === void 0 ? void 0 : _a.title) ? location.href = adsObj.ads.adclick : _this.historyItem(query);
      } else {
        _this.historyItem(query);
      }
    };
    _this.historyItem = function (query) {
      var index = _this.browsingHistoryList.findIndex(function (res) {
        return res === query;
      });
      var list = _this.browsingHistoryList || [];
      if (index !== -1) {
        list.splice(index, 1);
      }
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      (query === null || query === void 0 ? void 0 : query.trim()) !== "" && list.unshift(query);
      _this.browsingHistoryList = _toConsumableArray(list);
      localStorage.setItem("browsingHistoryList", JSON.stringify(list));
      window.open("".concat(_this.props.www, "/index-search.html?keyword=").concat(query));
    };
    _this.fetch = function () {
      return __awaiter(_assertThisInitialized(_this), void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this3 = this;
        var _a, _b, res, dur;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.props.fetchSearchRecommend({
                  ads: 1
                });
              case 2:
                res = _context2.sent;
                this.duration = (((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.default) || []).map(function (item) {
                  return item.text;
                });
                this.duration.reverse();
                if (res && res.status === 12000) {
                  this.setState({
                    recommend: res.data.hotSearch,
                    default: res.data.default
                  });
                  postInitialCollect(res.data.hotSearch[0].ads, "show");
                }
                dur = (_b = this.duration) === null || _b === void 0 ? void 0 : _b.length;
                this.setTimeDuration = setInterval(function () {
                  dur--;
                  if (dur <= 0) {
                    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                    _this3.setTimeDuration && clearInterval(_this3.setTimeDuration);
                    _this3.intervalDuration(_this3.duration.length);
                  }
                  _this3.setState({
                    placeholder: _this3.duration[dur]
                  });
                }, 3000);
              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    };
    _this.close = function () {
      _this.setState({
        cursor: -1,
        mentions: [],
        keyword: ""
      });
      _this.props.toggle(false);
    };
    _this.ad = function (data) {
      _this.props.ga(["关键字搜寻", "热门厂牌", data.text]);
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      data.ads && _this.props.postInitialCollect(data.ads, "click", "searchKeyword");
    };
    return _this;
  }
  _createClass(SearchPopover, [{
    key: "intervalDuration",
    value: function intervalDuration(duration) {
      var _this4 = this;
      var dur = duration;
      this.setTimeDuration = setInterval(function () {
        dur--;
        if (dur <= 0) {
          // eslint-disable-next-line @typescript-eslint/no-unused-expressions
          _this4.setTimeDuration && clearInterval(_this4.setTimeDuration);
          _this4.intervalDuration(_this4.duration.length);
        }
        _this4.setState({
          placeholder: _this4.duration[dur]
        });
      }, 3000);
    }
  }, {
    key: "ga4Item",
    value: function ga4Item() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this5 = this;
        var obj, params;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                obj = this.state.default.filter(function (_) {
                  return _.text === _this5.state.placeholder;
                })[0];
                params = {
                  page_name: this.pageName,
                  module: "搜索欄",
                  sub_module: "搜索框",
                  element: this.state.keyword === "" ? "搜索框推薦詞" : "搜索框輸入詞",
                  element_id: this.state.keyword === "" ? this.state.placeholder : this.state.keyword,
                  object_type: obj && (obj.type === "article" ? "文章" : obj.type === "kind" ? "車款" : ""),
                  object_id: obj && (obj.type === "article" ? obj.articleId : obj.type === "kind" ? obj.kindId : "")
                }; // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                this.state.keyword !== "" && this.props.ga4Collect("element_exposured", params);
                this.props.ga4Collect("element_clicked", params);
              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this6 = this;
      var browsingHistoryList = localStorage.getItem("browsingHistoryList");
      if (browsingHistoryList) {
        this.browsingHistoryList = _toConsumableArray(JSON.parse(browsingHistoryList));
      }
      this.pageName = "".concat(window.location.origin.indexOf("auto") > -1 ? "搜索輸入頁" : window.location.pathname === "/" ? "首頁" : window.location.pathname.indexOf("Summary.html") > -1 ? "綜述頁-首頁" : "搜索輸入頁");
      if (!document) {
        setTimeout(function () {
          _this6.fetch();
        }, 1000);
        return;
      }
      document.addEventListener("DOMContentLoaded", function () {
        _this6.fetch();
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this7 = this;
      var first = true;
      if (!prevProps.visible && this.props.visible && this.inputRef.current) {
        if (first) {
          this.state.recommend.forEach(function (item) {
            _this7.props.ga4Collect("element_exposured", {
              page_name: _this7.pageName,
              module: "搜索欄",
              sub_module: "熱門",
              element: "熱門推薦詞",
              element_id: item.text,
              object_type: item.type === "kind" ? "車款" : "廠牌",
              object_id: item.type === "kind" ? item.kindId : item.brandId
            });
          });
          this.state.default.forEach(function (item) {
            _this7.props.ga4Collect("element_exposured", {
              page_name: _this7.pageName,
              module: "搜索欄",
              sub_module: "搜索框",
              element: "搜索框推薦詞",
              element_id: item.text,
              object_type: item.type === "article" ? "文章" : item.type === "kind" ? "車款" : "",
              object_id: item.type === "article" ? item.articleId : item.type === "kind" ? item.kindId : ""
            });
          });
          first = false;
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this8 = this;
      var _this$props = this.props,
        visible = _this$props.visible,
        www = _this$props.www,
        image = _this$props.image;
      var _this$state2 = this.state,
        recommend = _this$state2.recommend,
        keyword = _this$state2.keyword,
        placeholder = _this$state2.placeholder,
        historyShow = _this$state2.historyShow,
        resultShow = _this$state2.resultShow,
        resultList = _this$state2.resultList;
      return /*#__PURE__*/React.createElement("div", {
        className: cx("tc-search-popover", {
          show: visible
        }),
        // 统一改成置顶预留间隙
        style: {
          top: visible ? "0px" : "-100vh"
        },
        onClick: this.handleContainerClick
      }, /*#__PURE__*/React.createElement("div", {
        className: 'tc-search-popover-header'
      }, /*#__PURE__*/React.createElement("img", {
        className: 'tc-search-popover-logo',
        src: 'https://img.8891.com.tw/v3/logo.png',
        alt: 'sp-logo'
      }), /*#__PURE__*/React.createElement("span", {
        className: 'tc-search-popover-close',
        onClick: this.close
      })), /*#__PURE__*/React.createElement("div", {
        className: 'tc-search-popover-content'
      }, /*#__PURE__*/React.createElement("div", {
        className: 'tc-search-popover-input'
      }, /*#__PURE__*/React.createElement("input", {
        id: 'tcSearchInput',
        ref: this.inputRef,
        placeholder: placeholder,
        onChange: this.handleInput,
        onKeyDown: this.handleKeyDown,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        value: keyword
      })), /*#__PURE__*/React.createElement("button", {
        className: 'tc-search-popover-btn',
        onClick: function onClick() {
          _this8.props.ga(["关键字搜寻", "搜寻按钮", "弹出页搜寻按钮"]);
          _this8.ga4Item();
          _this8.jump();
        }
      }, "\u641C\u5C0B"), (historyShow || resultShow) && /*#__PURE__*/React.createElement("div", {
        className: 'tc-search-popover-drop'
      }, historyShow && /*#__PURE__*/React.createElement("div", {
        className: 'history'
      }, /*#__PURE__*/React.createElement("p", null, "\u641C\u5C0B\u8A18\u9304", " ", /*#__PURE__*/React.createElement("span", {
        onClick: function onClick() {
          _this8.browsingHistoryList = [];
          localStorage.removeItem("browsingHistoryList");
          _this8.setState({
            historyShow: false
          });
        }
      }, "\u6E05\u9664")), /*#__PURE__*/React.createElement("ul", null, Array.isArray(this.browsingHistoryList) && this.browsingHistoryList.map(function (item, index) {
        return /*#__PURE__*/React.createElement(React.Fragment, {
          key: index
        }, index < 8 && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
          href: "".concat(www, "/index-search.html?keyword=").concat(item),
          target: '_blank',
          onClick: function onClick() {
            _this8.props.ga4Collect("element_clicked", {
              page_name: _this8.pageName,
              module: "搜索欄",
              sub_module: "搜索框",
              element: "下拉歷史推薦詞",
              element_id: item
            });
          },
          rel: 'noreferrer'
        }, item)));
      }))), resultShow && /*#__PURE__*/React.createElement("div", {
        className: 'results'
      }, Array.isArray(resultList) && resultList.map(function (item, index) {
        return /*#__PURE__*/React.createElement(React.Fragment, {
          key: index
        }, item.type === "brand" && /*#__PURE__*/React.createElement("div", {
          className: 'brand',
          onClick: function onClick() {
            _this8.historyItem(item.data.title);
            _this8.props.ga4Collect("element_clicked", {
              page_name: _this8.pageName,
              module: "搜索欄",
              sub_module: "搜索框",
              element: "下拉框推薦詞",
              element_id: item.data.title,
              object_type: "廠牌"
            });
          }
        }, /*#__PURE__*/React.createElement("img", {
          src: item.data.icon
        }), /*#__PURE__*/React.createElement("p", {
          dangerouslySetInnerHTML: {
            __html: _this8.highLight(item.data.title, keyword)
          }
        })), item.type === "kind" && /*#__PURE__*/React.createElement("div", {
          className: 'kind'
        }, /*#__PURE__*/React.createElement("div", {
          className: 'title',
          onClick: function onClick() {
            _this8.historyItem(item.data.title);
            _this8.props.ga4Collect("element_clicked", {
              page_name: _this8.pageName,
              module: "搜索欄",
              sub_module: "搜索框",
              element: "下拉框推薦詞",
              element_id: item.data.title,
              object_type: "車款",
              object_id: item.data.kindId
            });
          },
          dangerouslySetInnerHTML: {
            __html: _this8.highLight(item.data.title, keyword)
          }
        }), /*#__PURE__*/React.createElement("div", {
          className: 'btn'
        }, item.data.inquiry === 1 && /*#__PURE__*/React.createElement("a", {
          href: "https://c.8891.com.tw/ask/price?b=".concat(item.data.brandId, "&k=").concat(item.data.kindId, "&source=\u9996\u9801\u641C\u5C0B-\u8F2A\u5165\u5F15\u5C0E"),
          target: '_blank',
          onClick: function onClick() {
            _this8.props.ga4Collect("element_clicked", {
              page_name: _this8.pageName,
              module: "搜索欄",
              sub_module: "搜索框",
              element: "下拉框推薦詞",
              element_id: "一鍵詢價",
              object_type: "廠牌、車款",
              object_id: "".concat(item.data.brandId, "\u3001").concat(item.data.kindId)
            });
          },
          rel: 'noreferrer'
        }, "\u4E00\u9375\u8A62\u50F9"), item.data.saleStop === 0 && /*#__PURE__*/React.createElement("a", {
          href: "https://c.8891.com.tw/photoModel-balance.html?k=".concat(item.data.kindId),
          target: '_blank',
          onClick: function onClick() {
            _this8.props.ga4Collect("element_clicked", {
              page_name: _this8.pageName,
              module: "搜索欄",
              sub_module: "搜索框",
              element: "下拉框推薦詞",
              element_id: "配備",
              object_type: "廠牌、車款",
              object_id: "".concat(item.data.brandId, "\u3001").concat(item.data.kindId)
            });
          },
          rel: 'noreferrer'
        }, "\u914D\u5099"))), item.type === "article" && /*#__PURE__*/React.createElement("div", {
          className: 'article',
          onClick: function onClick() {
            _this8.historyItem(item.data.title);
            _this8.props.ga4Collect("element_clicked", {
              page_name: _this8.pageName,
              module: "搜索欄",
              sub_module: "搜索框",
              element: "下拉框推薦詞",
              element_id: item.data.title,
              object_type: "文章"
            });
          }
        }, /*#__PURE__*/React.createElement("p", {
          dangerouslySetInnerHTML: {
            __html: _this8.highLight(item.data.title, keyword)
          }
        })));
      })))), /*#__PURE__*/React.createElement("div", {
        className: 'tc-search-popover-extra'
      }, /*#__PURE__*/React.createElement("p", null, "\u71B1\u9580\uFF1A"), /*#__PURE__*/React.createElement("ul", null, Array.isArray(recommend) && recommend.map(function (item, index) {
        return /*#__PURE__*/React.createElement("li", {
          key: index,
          className: item.ads ? "tc-item-ads" : ""
        }, /*#__PURE__*/React.createElement("a", {
          href: item.ads && item.ads.adclick ? item.ads.adclick : "".concat(c, "/photoModel-info.html?k=").concat(item.kindId),
          target: '_blank',
          onClick: function onClick() {
            _this8.ad(item);
            _this8.props.ga4Collect("element_clicked", {
              page_name: _this8.pageName,
              module: "搜索欄",
              sub_module: "熱門",
              element: "熱門推薦詞",
              element_id: item.text,
              object_type: item.type === "kind" ? "車款" : "廠牌",
              object_id: item.type === "kind" ? item.kindId : item.brandId
            });
          },
          rel: 'noreferrer'
        }, item.ads && /*#__PURE__*/React.createElement("img", {
          src: "".concat(image, "/nav/hot.png"),
          alt: ''
        }), item.text));
      }))));
    }
  }]);
  return SearchPopover;
}(React.Component);
export default SearchPopover;